var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfericaoPaciente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.234,
    height: 55,
    viewBox: "0 0 41.234 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#16679a;}.b{fill:#0899ba;font-size:33px;font-family:Nunito-Bold, Nunito;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-650 -219)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(206 0.493)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.262,3.733H26.426a6.261,6.261,0,0,0-11.456,0H6.135A6.077,6.077,0,0,0,.082,9.793v39.17A6.057,6.057,0,0,0,6.135,55H35.262a6.058,6.058,0,0,0,6.053-6.037V9.793A6.077,6.077,0,0,0,35.262,3.733Zm-19.3,2.749a1.364,1.364,0,0,0,1.342-1.068,3.5,3.5,0,0,1,6.783,0,1.368,1.368,0,0,0,1.343,1.072h2.688V7.711a3.277,3.277,0,0,1-3.247,3.307H16.528a3.277,3.277,0,0,1-3.251-3.3V6.482Zm22.6,42.481a3.306,3.306,0,0,1-3.3,3.288H6.135a3.305,3.305,0,0,1-3.3-3.288V9.793a3.325,3.325,0,0,1,3.3-3.311h4.393V7.71a6.028,6.028,0,0,0,6,6.057h8.341a6.029,6.029,0,0,0,6-6.057V6.482h4.392a3.325,3.325,0,0,1,3.3,3.311Zm0,0",
    transform: "translate(443.918 218.507)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(464 259)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.9,
    y: 0
  }, "+"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfericaoPaciente);
export default __webpack_public_path__ + "static/media/afericao-paciente.db96394ffcb32735a4e8b34612eabace.svg";
export { ForwardRef as ReactComponent };